<template>
    <div>
        <div class="subtitle-2 mb-2">Kolommen</div>
        <v-list dense class="py-0">
            <draggable :value="columns" handle=".handle" animation="200" @input="changeOrder">
                <v-list-item v-for="(column, index) in columns" :key="updateListKey+'_'+index" class="px-0">
                    <v-list-item-action class="handle my-0 mr-2">
                        <v-icon>mdi-drag</v-icon>
                    </v-list-item-action>
                    <v-list-item-content class="py-1">
                        <eod-text-field dense outlined hide-details label="Naam" :value="column.text" @input="val => updateColumn(index, 'text', val)"></eod-text-field>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                        <v-btn icon color="error" @click="deleteColumn(index)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                    </v-list-item-action>
                </v-list-item>
            </draggable>
        </v-list>
        <v-btn rounded text color="primary" class="mt-2" @click="addColumn"><v-icon left>mdi-plus</v-icon>Kolom toevoegen</v-btn>
    </div>
</template>
<style lang="scss" scoped>
.handle{
    cursor: grab;
}
</style>
<script>
import draggable from 'vuedraggable';

export default {
    name: 'eod-measurementType-columns',
    components: {
        draggable
    },
    props: {
        value: Array
    },
    data: () => ({
        updateListKey: 98343
    }),
    computed: {
        columns() {
            return this.value || [];
        }
    },
    methods: {
        addColumn() {
            const columns = [...this.columns];
            columns.push({ text: '' });
            this.$emit('input', columns);
        },
        updateColumn(index, propertyName, val) {
            const columns = [...this.columns];
            columns[index] = { ...columns[index], [propertyName]: val };
            this.$emit('input', columns);
        },
        deleteColumn(index) {
            const columns = [...this.columns];
            columns.splice(index, 1);
            this.$emit('input', columns);
            this.updateListKey++;
        },
        changeOrder(columns) {
            this.$emit('input', columns);
            this.updateListKey++;
        }
    }
}
</script>
